import { ethers } from "ethers";
import { getAddressUSDC } from "./getAddressUSDC";
import production from './abi/usdc.json';

export async function getUSDContract(provider) {
    const signer = provider.getSigner();
    const contract = new ethers.Contract(getAddressUSDC(), production, signer);
    return contract;
}